module.exports = __webpack_public_path__ + "media/images/icons/filled/gold-b6f9ae89c1738b7ce44fc868897f2e6d.svg";